export default __webpack_public_path__ + "static/media/Certificate-Active.6cd33d1d.svg";